module.exports = __webpack_public_path__ + "static/media/defaultstate-loading.bd90b16f.gif";